import { useEffect, useState } from 'react';

/** Subscribes to a media query. Returns `false` where `matchMedia` is absent. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const media = window.matchMedia(query);
    const listen = (): void => setMatches(media.matches);
    listen();
    media.addEventListener('change', listen);
    return () => media.removeEventListener('change', listen);
  }, [query]);

  return matches;
}

/** Below this width the app switches to its tabbed mobile layout. */
export const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}

export function useIsLandscape(): boolean {
  return useMediaQuery('(orientation: landscape)');
}

/** True on devices whose primary pointer cannot hover — phones and tablets. */
export function useIsCoarsePointer(): boolean {
  return useMediaQuery('(pointer: coarse)');
}
